module.exports = __webpack_public_path__ + "img/jt_red@2x.fa35c79c.png";